
export default class SwitchLanguageNotice {
	static init() {
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			return;
		}

		// lighthouse is considered a english-speaker, which is not our main target audience
		const isLighthouse = /Google Page Speed Insights/.test(navigator.userAgent) || /Chrome-Lighthouse/.test(navigator.userAgent);
		if (isLighthouse) {
			return;
		}

		Array.prototype.forEach.call(document.querySelectorAll('.switch-language-notice'), element => {
			new SwitchLanguageNotice(element);
		});
	}

	constructor(element) {
        const lastUsed = localStorage.getItem('language-switcher-used');
        const hideBefore = new Date(lastUsed);
        hideBefore.setMinutes(hideBefore.getMinutes() + 10);
        if (lastUsed && hideBefore > new Date()) {
            return;
        }

        this.element = element;
		const currentLanguage = document.querySelector('html').getAttribute('lang') || 'de';
		const preferredLanguage = navigator.language || navigator.userLanguage;

		// did the user already dismiss the language switcher?
		if(localStorage.getItem('language-switcher-dismissed')) {
			return;
		}

		// should we prompt the user to change language?
		const recommendedLanguage = this.getBestMatchingLanguage(preferredLanguage.replace('-', '_'));
		if(!recommendedLanguage || recommendedLanguage === currentLanguage) {
			return;
		}

		// preselect the matching user language
		const recommendedOption = element.querySelector('option[hreflang="' + recommendedLanguage + '"]');
		recommendedOption.selected = 'selected'; // if page-select is not initialized yet
		const customSelectOption = this.element.querySelector('.dropdown-option[data-key="' + recommendedOption.getAttribute('value') + '"]');
		if (customSelectOption) customSelectOption.click();

		// translate the labels
		const translations = {
			text: {
				'de': 'Möchten Sie die Sprache wechseln?',
				'en': 'Do you want to change the language?',
				'es': '¿Quieres cambiar de idioma?',
			},
			submit: {
				'de': 'Weiter',
				'en': 'Go',
				'es': 'Go',
			}
		}
		this.element.querySelector('.switch-language-notice__text').innerText = translations.text[recommendedLanguage];
		this.element.querySelector('.switch-language-notice__submit-button').value = translations.submit[recommendedLanguage];

		// show the notice
		document.querySelector('body').classList.add('body--switch-language-notice-is-visible');
		this.element.querySelector('.switch-language-notice__close-button').addEventListener('click', (e) => {
			e.preventDefault();
			localStorage.setItem('language-switcher-dismissed', '1');
			document.querySelector('body').classList.remove('body--switch-language-notice-is-visible');
			this.element.dispatchEvent(new Event('language-switcher-dismissed')); // public api
		});
		this.element.querySelector('.switch-language-notice__submit-button').addEventListener('click', (e) => {
			e.preventDefault();
            localStorage.setItem('language-switcher-used', (new Date()).toISOString());
			window.location = this.element.querySelector('.page-select').value;
		});
	}

	/**
	 * @param preferredLanguage in the form "de_DE"
	 * @returns {string|null}
	 */
	getBestMatchingLanguage(preferredLanguage) {
		const languages = this.getAvailableLanguages();
		if (languages.indexOf(preferredLanguage) !== -1) {
			return preferredLanguage;
		}

		const mainLanguage = preferredLanguage.split('_')[0];
		if (languages.indexOf(mainLanguage) !== -1) {
			return mainLanguage;
		}

		if (languages.indexOf('en') !== -1) {
			return 'en';
		}

		return null;
	}

	getAvailableLanguages() {
		const options = Array.from(this.element.querySelectorAll('.page-select option'));
		return options.map(option => option.getAttribute('hreflang'));
	}
}
